// extracted by mini-css-extract-plugin
export default {"home_container":"home_home_container__nLRD5","header":"home_header__NETg5","content":"home_content__O8XY3","sidebar":"home_sidebar__+ahmP"};